import { Component, Input, OnInit } from '@angular/core'; // Import Input and OnInit
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-resolution-success',
  templateUrl: './resolution-success.page.html',
  styleUrls: ['./resolution-success.page.scss'],
})
export class ResolutionSuccessPage {

  @Input() custom_key: any;

  constructor(
    protected modalCtrl: ModalController
  ) { }

}
